import Axios from './caller.service';

let contacter = (message) => {
  return Axios.put('/contact', message);
}

export const contactService = {
    contacter
}